export default __webpack_public_path__ + "static/media/emptychat1.7d2a778e.svg";